import { configureStore } from "@reduxjs/toolkit";
import formationReducer   from "../../features/shared/store/slices/formationSlice";
import catalogueReducer   from "../../features/shared/store/slices/catalogueSlice";
import moduleReducer      from "../../features/shared/store/slices/moduleSlice";
import contenuReducer     from "../../features/shared/store/slices/contenuSlice";
import quizReducer        from "../../features/shared/store/slices/quizSlice";
import inscriptionReducer from "../../features/shared/store/slices/inscriptionSlice";
import progressionReducer from "../../features/shared/store/slices/progressionSlice";
import certificatReducer  from "../../features/shared/store/slices/certificatSlice";
import messagerieReducer  from "../../features/shared/store/slices/messagerieSlice";
import notificationReducer from "../../features/shared/store/slices/notificationSlice";
import themeReducer        from "../../features/shared/store/slices/themeSlice";

const store = configureStore({
  reducer: {
    formations:    formationReducer,
    catalogues:    catalogueReducer,
    modules:       moduleReducer,
    contenus:      contenuReducer,
    quiz:          quizReducer,
    inscriptions:  inscriptionReducer,
    progressions:  progressionReducer,
    certificats:   certificatReducer,
    messagerie:    messagerieReducer,
    notifications: notificationReducer,
    themes:        themeReducer,
  },
});

export default store;
